import { useTranslation } from "react-i18next";
import { tv } from "tailwind-variants";
import bdoLogo from "@/assets/bdo.png";
import labs from "@/assets/labs.png";
import { RiInformationLine } from "@remixicon/react";

export function Footer() {
  const { t } = useTranslation("translation", {
    keyPrefix: "common.footer",
  });

  const slots = tv({
    slots: {
      footer:
        "bg-mono-darker text-white px-lg py-sm flex items-center justify-between gap-sm w-full z-10",
      leftContainer: "flex gap-sm items-start w-full",
      rightContainer:
        "flex gap-md max-h-[30px] min-w-fit items-center justify-end",
    },
  });

  const { footer, leftContainer, rightContainer } = slots();

  return (
    <footer className={footer()}>
      <div className={leftContainer()}>
        <span className="min-w-[24px]">
          <RiInformationLine className="text-lg" />
        </span>
        <p className="text-[0.875rem]">
          {t("disclaimerStart")}
          <a
            href="https://bdouk.sharepoint.com/sites/LearningPathways/SitePages/LearnAI.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-link-lighter hover:text-link-light"
          >
            {t("learnItLink")}
          </a>
          {t("disclaimerMiddle")}
          <a
            href="https://insite.bdo.co.uk/sites/IT/aboutit/innovationdigital/ai/Pages/Our-guidance-on-the-use-of-AI.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-link-lighter hover:text-link-light"
          >
            {t("insiteLink")}
          </a>
          {t("disclaimerEnd")}
          <a
            href="https://insite.bdo.co.uk/sites/knowledge/redirects/Pages/go.aspx?title=itsupporthub"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-link-lighter hover:text-link-light"
          >
            {t("hereLink")}
          </a>
          {t("disclaimerFinal")}
        </p>
      </div>
      <div className={rightContainer()}>
        <img src={labs} alt="Labs Logo" />
        <img src={bdoLogo} alt="BDO Logo" />
      </div>
    </footer>
  );
}
